const FIRST_FAVORITES_NUDGE_DELAY_MS = 1000;
const PDP_SHOW_FAVORITES_NUDGE_DURATION_MS = 8000;
const MAX_FAVORITES_NUDGE_DISPLAY_COUNT = 4;
const HIDE_NUDGE_ITEM_FAVORITE_COUNT = 4;

const FAVORITES_LOCAL_STORAGE_KEYS = {
    FAVORITES_NUDGE_HIDE: 'favoritesNudgeHide',
    FAVORITES_NUDGE_DISPLAYED_COUNT: 'favoritesNudgeDisplayedCount',
};

const FAVORITES_SESSION_STORAGE_KEYS = {
    FAVORITES_NUDGE_DISPLAYED: 'favoriteNudgeDisplayed',
};

export {
    FIRST_FAVORITES_NUDGE_DELAY_MS,
    PDP_SHOW_FAVORITES_NUDGE_DURATION_MS,
    MAX_FAVORITES_NUDGE_DISPLAY_COUNT,
    HIDE_NUDGE_ITEM_FAVORITE_COUNT,
    FAVORITES_LOCAL_STORAGE_KEYS,
    FAVORITES_SESSION_STORAGE_KEYS,
};
